import React, { useState } from 'react'
import { Text } from 'recharts'
import { MachineDetails } from './machineDetails'
import { SaveModal } from '../../components/molecules/SavingModal'
import { PatchToBackoffice } from '../../utils/commands'

interface PushFirmwareModalProps {
  open: boolean
  closeModal: () => void
  details: MachineDetails | undefined
}

export default function PushFirmwareModal(props: PushFirmwareModalProps): React.ReactElement {
  const [saving, setSaving] = useState<boolean>(false)
  const [savingFailed, setSavingFailed] = useState<boolean | null>(null)

  const serialNumber = props.details?.serialNumber

  const onPush = async () => {
    if (!serialNumber) return
    setSaving(true)
    try {
      const res = await PatchToBackoffice('machines/push-latest-ATMega-firmware', { serialNumbers: [serialNumber] })
      setSavingFailed(!res.successful.includes(serialNumber))
    } catch (e) {
      setSavingFailed(true)
    } finally {
      setSaving(false)
    }
  }

  return (
    <SaveModal
      title={'Push latest firmware'}
      open={props.open}
      savingFailedMessage={'Pushing firmware failed! Try again later.'}
      savingSuccessMessage={'Firmware pushed successfully.'}
      saveButtonText={'Push'}
      closeModal={() => { props.closeModal() } }
      onSave={onPush}
      saving={saving}
      savingFailed={savingFailed === true}
      savingSuccessful={savingFailed === false}
      setSavingFailed={setSavingFailed} 
      savingOngoing={false}
    >
      <Text>
        This action will push the latest firmware from the database to the machine.
        Ensure that the affected store is notified beforehand.
      </Text>
    </SaveModal>
  )
}
